<template>
  <b-table
    responsive
    class="table-list"
    :items="items"
    :fields="fields"
    :busy="isBusy"
    show-empty
    :empty-text="$t('noData')"
  >
    <template v-slot:table-busy>
      <div class="text-center text-black my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong class="ml-2">Loading...</strong>
      </div>
    </template>

    <template v-slot:cell(name)="data">
      <div v-if="data.item.isMatchingPhrases">
        <InputText
          textFloat=""
          placeholder="Name"
          type="text"
          :name="data.item.name"
          v-model="data.item.name"
          :isValidate="v.form.conditions.$each[data.index].name.$error"
          :v="v.form.conditions.$each[data.index].name"
        />
      </div>
      <div v-else>{{ data.item.name }}</div>
    </template>
    <template v-slot:cell(isActiveMatchingPhrases)="data">
      <div v-if="data.item.isMatchingPhrases">
        <toggle-button
          class="mt-1 mr-1"
          v-model="data.item.isActiveMatchingPhrases"
          :color="{
            checked: '#27BDA7',
            unchecked: '#B0B0B0',
          }"
        />
      </div>
    </template>
    <template v-slot:cell(score)="data">
      <div class="input-score-wrapper">
        <InputNumber
          textFloat=""
          placeholder="Score"
          :name="data.item.name + data.item.score"
          v-model="data.item.score"
          class="w-20"
          :isValidate="v.form.conditions.$each[data.index].score.$error"
          :v="v.form.conditions.$each[data.index].score"
        />
      </div>
    </template>
    <template v-slot:cell(isActive)="data">
      <div class="d-flex justify-content-center">
        <b-link
          class="text-link"
          @click="onEdit(data.item)"
          v-if="!data.item.isMatchingPhrases"
        >
          <font-awesome-icon
            icon="pencil-alt"
            class="text-warning"
            title="Edit"
          />
        </b-link>
        <b-link class="text-link ml-3" @click="onDelete(data.item)">
          <font-awesome-icon
            icon="trash-alt"
            class="text-danger"
            title="Delete"
          />
        </b-link>
      </div>
    </template>
  </b-table>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputNumber from "@/components/inputs/InputNumber";
export default {
  name: "SettingWordListTable",
  components: {
    InputNumber,
    InputText,
  },
  props: {
    isBusy: {
      type: Boolean,
      require: true,
      default: false,
    },
    items: {
      type: Array,
      require: true,
      default: [],
    },
    fields: {
      type: Array,
      require: true,
      default: [],
    },
    v: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  methods: {
    onEdit(item) {
      this.$emit("onEdit", item);
    },
    onDelete(item) {
      this.$emit("onDelete", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-score-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
